import React from 'react'
import Subheading from '../../components/Text/Subheading'
import Icon from '../../components/Text/Icon'
import HorizontalDivider from '../../components/Dividers/HorizontalDivider'
import Select from '../../components/Inputs/Select'
import Toggle from '../../components/Inputs/Toggle'
import ButtonDanger from '../../components/Buttons/ButtonDanger'

export default function ProjectSettings({
    onClose,
    gridScale,
    setGridScale,
    publicAccess,
    setPublicAccess,
    onDelete,
}) {
    return (
        <div className='flex flex-col gap-6 p-4 px-6 w-3/5 h-full border-r shadow-md lg:w-1/5 border-dark-100'>
            <div className='flex flex-row gap-2 justify-between items-center -mb-4 w-full'>
                <Subheading className='!pb-0'>Project Settings</Subheading>
                <div className='flex flex-row gap-2 items-center mt-3'>
                    <div onClick={onClose} className='cursor-pointer'><Icon icon='x' className='text-2xl' /></div>
                </div>
            </div>
            <HorizontalDivider />
            <div className='flex justify-between items-center'>
                <Subheading className='!text-md lg:!text-lg !font-medium'>Grid Size</Subheading>
                <div className='flex justify-center items-center w-1/3' >
                    <Select className='!w-32' options={[{id: -1,value: 'No grid'},{id: 5,value: 'Small'},{id: 10,value: 'Medium'},{id: 20,value: 'Large'}]} currentOption={gridScale} setCurrentOption={setGridScale} />
                </div>
            </div>
            <div className='flex justify-between items-center'>
                <Subheading className='!text-md lg:!text-lg !font-medium'>Enable Public Access</Subheading>
                <div className='flex justify-center items-center w-1/3' >
                    <Toggle className='p-1' checked={publicAccess} setChecked={setPublicAccess} />
                </div>
            </div>
            <HorizontalDivider />
            <ButtonDanger onClick={onDelete}>Delete Project</ButtonDanger>
        </div>
    )
}
